// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const SearchMdIcon = /* @__PURE__ */ createIcon(
  'search-md',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M18 11a7 7 0 1 0-2.137 5.032 1 1 0 0 1 .17-.169A6.98 6.98 0 0 0 18 11m2 0a8.96 8.96 0 0 1-1.97 5.616l3.677 3.677a1 1 0 1 1-1.414 1.414l-3.677-3.677A9 9 0 1 1 20 11',
      },
    ],
  ]
);
